// FIRST import on purpose: this initializes Sentry before any app module
// is evaluated, so errors thrown during initial render are still captured.
import './sentry';

import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';

//
import App from './App';
import * as serviceWorker from './serviceWorker';
import reportWebVitals from './reportWebVitals';

// ----------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root'));

// Sentry.ErrorBoundary reports render-time crashes (which React swallows
// rather than surfacing to window.onerror) and, just as importantly,
// replaces the blank white page a crash used to leave behind.
root.render(
  <Sentry.ErrorBoundary
    fallback={
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 24,
          textAlign: 'center',
          fontFamily: '"Kufam", "Helvetica Neue", Arial, sans-serif',
          color: '#242258',
          background: '#FCFBF7',
        }}
      >
        <h1 style={{ fontSize: 28, margin: 0 }}>Something went wrong.</h1>
        <p style={{ maxWidth: 460, lineHeight: 1.6, color: '#5D5D9C' }}>
          Sorry — this page hit an error and our team has been notified. Please
          refresh to try again, or call the office if you need a hand.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{
            marginTop: 8,
            padding: '12px 28px',
            border: 'none',
            background: '#242258',
            color: '#fff',
            fontWeight: 700,
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
            cursor: 'pointer',
            width: 'auto',
          }}
        >
          Refresh
        </button>
      </div>
    }
  >
    <App />
  </Sentry.ErrorBoundary>
);

// If you want to enable client cache, register instead.
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
